import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const MODEL_COMPONENTS_MODEL_COMPONENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/model-components',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:ModelComponents',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.ModelComponents',
      },
    ]);
  };
}
